import { required, yup } from "./CommonValidation";
import * as Yup from 'yup';
export const CenterSchema = (type) => { 
    // const phoneRegExp = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
        const numberRegExp = /^\d+$/
// const nameRegExp = /[A-Za-z]+$/;
const nameRegExp = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?0123456789]+/;
const regexp = /\s/g
    if (type === 'ADD_CENTER') {
        return yup({
            center_name: required('Center Name is required.')
            .test('valid', 'Center Name must be in character.', (val= '')=> {
                if (nameRegExp.test(val)) {
                    return false;
                } else {
                    return true;
                }
              
            }).max(25, 'Center Name must have maximum 150 characters.'),
            contact_no:  required("Please enter contact no")
               .test('valid', 'Contact Number is not valid.', (val = '') => {
                const checkLength = val.replace(/\(|\)/g, '').length;
                if (checkLength === 0) {
                    return true;
                }
                if (numberRegExp.test(val)) {
                    return true;
                }
                return false;
            })
            .test('empty', 'Contact Number is required.', (val = '') => {
                const checkLength = val.replace(/\(|\)/g, '').length;
                return checkLength > 0;
            })
             .min(10, 'Contact Number must be 10 digits.')
            .max(14, 'Contact Number must be 10 digits.'),
            email: required("Please enter email").email('Please enter a valid email address.'),
            // gst_no: required('GST No is required.')
            // .min(15, 'GST Number must be 15 digits.')
            // .max(15, 'GST Number must be 15 digits.'),
            mobile:  required("Please enter contact no")
            .test('valid', 'Contact Number is not valid.', (val = '') => {
             const checkLength = val.replace(/\(|\)/g, '').length;
             if (checkLength === 0) {
                 return true;
             }
             if (numberRegExp.test(val)) {
                 return true;
             }
             return false;
         })
         .test('empty', 'Contact Number is required.', (val = '') => {
             const checkLength = val.replace(/\(|\)/g, '').length;
             return checkLength > 0;
         })
          .min(10, 'Contact Number must be 10 digits.')
         .max(14, 'Contact Number must be 10 digits.'),
            user_email: required("Please enter email").email('Please enter a valid email address.'),
           
        });
    }else if (type === 'ADD_CENTER_WITH_GST') {
        return yup({
            center_name: required('Center Name is required.')
            .test('valid', 'Center Name must be in character.', (val= '')=> {
                if (nameRegExp.test(val)) {
                    return false;
                } else {
                    return true;
                }
            }).max(25, 'Center Name must have maximum 150 characters.'),
            contact_no:  required("Please enter contact no")
               .test('valid', 'Contact Number is not valid.', (val = '') => {
                const checkLength = val.replace(/\(|\)/g, '').length;
                if (checkLength === 0) {
                    return true;
                }
                if (numberRegExp.test(val)) {
                    return true;
                }
                return false;
            })
            .test('empty', 'Contact Number is required.', (val = '') => {
                const checkLength = val.replace(/\(|\)/g, '').length;
                return checkLength > 0;
            })
             .min(10, 'Contact Number must be 10 digits.')
            .max(14, 'Contact Number must be 10 digits.'),
            email: required("Please enter email").email('Please enter a valid email address.'),
            gst_no: required('GST No is required.')
            .min(15, 'GST Number must be 15 digits.')
            .max(15, 'GST Number must be 15 digits.'),
      
            user_email: required("Please enter email").email('Please enter a valid email address.'),
           
        });
    } else if(type==='ADD_CENTER_USER'){
        return yup({
            center_id: required("Please select center"),
            fullName: required("Please enter full name")
            .test('valid', 'Full Name must be in character.', (val= '')=> {
                if (nameRegExp.test(val)) {
                    return false;
                } else {
                    return true;
                }
              
            }),
            mobile:  required("Please enter mobile no")
            .test('valid', 'Mobile Number is not valid.', (val = '') => {
             const checkLength = val.replace(/\(|\)/g, '').length;
             if (checkLength === 0) {
                 return true;
             }
             if (numberRegExp.test(val)) {
                 return true;
             }
             return false;
         })
         .test('empty', 'Mobile Number is required.', (val = '') => {
             const checkLength = val.replace(/\(|\)/g, '').length;
             return checkLength > 0;
         })
          .min(10, 'Mobile Number must be 10 digits.')
         .max(14, 'Mobile Number must be 10 digits.'),
            email: required("Please enter email").email('Please enter a valid email address.'),
            password: required("Please enter password"),
        })
    }else if (type === 'EDIT_CENTER_WITH_GST') {
        return yup({
            center_name: required('Center Name is required.')
            .test('valid', 'Center Name must be in character.', (val= '')=> {
                if (nameRegExp.test(val)) {
                    return false;
                } else {
                    return true;
                }
            }).max(25, 'Center Name must have maximum 150 characters.'),
            contact_no:  required("Please enter contact no")
               .test('valid', 'Contact Number is not valid.', (val = '') => {
                const checkLength = val.replace(/\(|\)/g, '').length;
                if (checkLength === 0) {
                    return true;
                }
                if (numberRegExp.test(val)) {
                    return true;
                }
                return false;
            })
            .test('empty', 'Contact Number is required.', (val = '') => {
                const checkLength = val.replace(/\(|\)/g, '').length;
                return checkLength > 0;
            })
             .min(10, 'Contact Number must be 10 digits.')
            .max(14, 'Contact Number must be 10 digits.'),
            email: required("Please enter email").email('Please enter a valid email address.'),
            gst_no: required('GST No is required.')
            .min(15, 'GST Number must be 15 digits.')
            .max(15, 'GST Number must be 15 digits.'),
           
        });
    }else if (type === 'EDIT_CENTER') {
        return yup({
            center_name: required('Center Name is required.')
            .test('valid', 'Center Name must be in character.', (val= '')=> {
                if (nameRegExp.test(val)) {
                    return false;
                } else {
                    return true;
                }
            }).max(25, 'Center Name must have maximum 150 characters.'),
            contact_no:  required("Please enter contact no")
               .test('valid', 'Contact Number is not valid.', (val = '') => {
                const checkLength = val.replace(/\(|\)/g, '').length;
                if (checkLength === 0) {
                    return true;
                }
                if (numberRegExp.test(val)) {
                    return true;
                }
                return false;
            })
            .test('empty', 'Contact Number is required.', (val = '') => {
                const checkLength = val.replace(/\(|\)/g, '').length;
                return checkLength > 0;
            })
             .min(10, 'Contact Number must be 10 digits.')
            .max(14, 'Contact Number must be 10 digits.'),
            email: required("Please enter email").email('Please enter a valid email address.'),
          
        });
    }else if(type==='operator'){
        return yup({
            fullName: required("Please enter full name"),
            mobile: required("Please enter mobile no"),
            email: required("Please enter email").email('Please enter a valid email address.'),
            location: required("Please enter location"),
            city: required("Please select center"),
            state: required("Please select state"),
            password: required("Please enter password"),
            center_id:required("Please select center"),
        })
    } else if(type==="ADD_DOCTOR"){
        return yup({
        
            email: required("Please enter email").email('Please enter a valid email address.'),
            address: required("Please enter location"),
        
            fullName: required("Please enter full name")
            .test('valid', 'Full Name must be in character.', (val= '')=> {
                if (nameRegExp.test(val)) {
                    return false;
                } else {
                    return true;
                }
            }),
            mobile: required("Please enter mobile no")
            .min(10, 'Mobile Number must be 10 digits.')
            .max(14, 'Mobile Number must be 10 digits.'),
            password: required("Please enter password"),
        })
    }
};